module.exports = __webpack_public_path__ + "static/AR0-8a7d1092022926f0dd73ae70e4fa0dff.jpg";